import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  usersRequest: ['page', 'page_size', 'sort_field', 'sort_order', 'role', 'search'],
  usersSuccess: ['list'],

  userRequest: ['userId'],
  userSuccess: ['userData'],
  userSetData: ['data'],

  userSaveRequest: ['data'],
  userSaveSuccess: ['saveResult'],
  userSaveReset: null,

  userSaveAvatarRequest: ['data'],
  userSaveAvatarSuccess: ['saveAvatarResult'],
  userSaveAvatarReset: null,

  userDeleteRequest: ['id'],
  userDeleteSuccess: ['deleteResult'],
  userDeleteReset: null,

  usersReset: null,
  userSearchReset: null,

  profileChangePasswordRequest: ['data'],
  profileChangePasswordSuccess: ['changePasswordResult'],

  userChangePasswordRequest: ['data'],
  userChangePasswordSuccess: ['changePasswordResult'],

  changePasswordReset: null,

  userChangeEmailRequest: ['data'],
  userChangeEmailSuccess: ['changeEmailResult'],
  userChangeEmailReset: null,

  userConfirmCodeRequest: ['data'],
  userConfirmCodeSuccess: ['confirmCodeResult'],
  userConfirmCodeReset: null,

  businessAreasRequest: null,
  businessAreasSuccess: ['businessAreas'],

  companyRolesRequest: null,
  companyRolesSuccess: ['companyRoles'],

  staffNumberRequest: null,
  staffNumberSuccess: ['staffList'],

  updateUserInfo: ['userId'],

  userFetchingReset: null,

  setVerificationLink: ['verificationLink']
})

export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  userData: null,

  saveResult: null,
  saveFetching: false,

  saveAvatarResult: null,
  saveAvatarFetching: false,

  deleteResult: null,
  deleteFetching: false,

  page: 1,
  page_size: 20,
  sort_field: 'id',
  sort_order: 1,
  search: '',
  role: '',

  businessAreas: null,
  companyRoles: null,
  staffList: null,

  changePasswordResult: null,
  changeEmailResult: null,
  confirmCodeResult: null,
  changeEmailFetching: false,

  verificationLink: null,
})

/* ------------- Selectors ------------- */
export const UserSelectors = {
  getState: state => state.users,
}

/* ------------- Reducers ------------- */

export const usersRequest = (state, {page, page_size, sort_field, sort_order, role, search}) => {
  const newState = {
    fetching: true,
  }
  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  sort_field && (newState.sort_field = sort_field)
  sort_order && (newState.sort_order = sort_order)
  role != null && (newState.role = role)
  search != null && (newState.search = search)
  return state.merge(newState)
}

export const usersSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const userRequest = (state, {userId}) => {
  return state
}

export const userSuccess = (state, {userData}) => {
  return state.merge({userData})
}

export const userSetData = (state, {data}) => {
  return state.merge({userData: data})
}

export const userSaveRequest = (state, {data}) => {
  return state.merge({saveFetching: true})
}

export const userSaveSuccess = (state, {saveResult}) => {
  return state.merge({saveFetching: false, saveResult})
}

export const userSaveReset = state => {
  return state.merge({saveFetching: false, saveResult: null})
}

/**/

export const userSaveAvatarRequest = (state, {data}) => {
  return state.merge({saveAvatarFetching: true})
}

export const userSaveAvatarSuccess = (state, {saveAvatarResult}) => {
  return state.merge({saveAvatarFetching: false, saveAvatarResult})
}

export const userSaveAvatarReset = state => {
  return state.merge({saveAvatarFetching: false, saveAvatarResult: null})
}

/**/

export const userDeleteRequest = (state, {id}) => {
  return state.merge({deleteFetching: true})
}

export const userDeleteSuccess = (state, {deleteResult}) => {
  return state.merge({deleteFetching: false, deleteResult})
}

export const userDeleteReset = state => {
  return state.merge({deleteFetching: false, deleteResult: null})
}

export const usersReset = state => {
  return INITIAL_STATE
}

export const userSearchReset = state => {
  return state.merge({search: ''})
}

export const profileChangePasswordRequest = (state, {data}) => {
  return state
}

export const profileChangePasswordSuccess = (state, {changePasswordResult}) => {
  return state.merge({changePasswordResult})
}

export const userChangePasswordRequest = (state, {data}) => {
  return state
}

export const userChangePasswordSuccess = (state, {changePasswordResult}) => {
  return state.merge({changePasswordResult})
}

export const changePasswordReset = state => {
  return state.merge({changePasswordResult: null})
}

export const businessAreasRequest = state => {
  return state
}

export const businessAreasSuccess = (state, {businessAreas}) => {
  return state.merge({businessAreas})
}

export const companyRolesRequest = state => {
  return state
}

export const companyRolesSuccess = (state, {companyRoles}) => {
  return state.merge({companyRoles})
}

export const staffNumberRequest = state => {
  return state
}

export const staffNumberSuccess = (state, {staffList}) => {
  return state.merge({staffList})
}

export const userChangeEmailRequest = (state, {data}) => {
  return state.merge({changeEmailFetching: true})
}

export const userChangeEmailSuccess = (state, {changeEmailResult}) => {
  return state.merge({changeEmailFetching: false, changeEmailResult})
}

export const userChangeEmailReset = state => {
  return state.merge({changeEmailResult: null})
}

export const userConfirmCodeRequest = (state, {data}) => {
  return state.merge({changeEmailFetching: true})
}

export const userConfirmCodeSuccess = (state, {confirmCodeResult}) => {
  return state.merge({changeEmailFetching: false, confirmCodeResult})
}

export const userConfirmCodeReset = state => {
  return state.merge({confirmCodeResult: null})
}

export const updateUserInfo = (state, {userId}) => {
  return state
}

export const userFetchingReset = state => {
  return state.merge({fetching: false, saveFetching: false, deleteFetching: false, changeEmailFetching: false})
}

export const setVerificationLink = (state, verificationLink) => {
  return state.merge({verificationLink})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.USERS_REQUEST]: usersRequest,
  [Types.USERS_SUCCESS]: usersSuccess,

  [Types.USER_REQUEST]: userRequest,
  [Types.USER_SUCCESS]: userSuccess,
  [Types.USER_SET_DATA]: userSetData,

  [Types.USER_SAVE_REQUEST]: userSaveRequest,
  [Types.USER_SAVE_SUCCESS]: userSaveSuccess,
  [Types.USER_SAVE_RESET]: userSaveReset,

  [Types.USER_SAVE_AVATAR_REQUEST]: userSaveAvatarRequest,
  [Types.USER_SAVE_AVATAR_SUCCESS]: userSaveAvatarSuccess,
  [Types.USER_SAVE_AVATAR_RESET]: userSaveAvatarReset,

  [Types.USER_DELETE_REQUEST]: userDeleteRequest,
  [Types.USER_DELETE_SUCCESS]: userDeleteSuccess,
  [Types.USER_DELETE_RESET]: userDeleteReset,

  [Types.USERS_RESET]: usersReset,
  [Types.USER_SEARCH_RESET]: userSearchReset,

  [Types.PROFILE_CHANGE_PASSWORD_REQUEST]: profileChangePasswordRequest,
  [Types.PROFILE_CHANGE_PASSWORD_SUCCESS]: profileChangePasswordSuccess,

  [Types.USER_CHANGE_PASSWORD_REQUEST]: userChangePasswordRequest,
  [Types.USER_CHANGE_PASSWORD_SUCCESS]: userChangePasswordSuccess,

  [Types.CHANGE_PASSWORD_RESET]: changePasswordReset,

  [Types.BUSINESS_AREAS_REQUEST]: businessAreasRequest,
  [Types.BUSINESS_AREAS_SUCCESS]: businessAreasSuccess,

  [Types.COMPANY_ROLES_REQUEST]: companyRolesRequest,
  [Types.COMPANY_ROLES_SUCCESS]: companyRolesSuccess,

  [Types.STAFF_NUMBER_REQUEST]: staffNumberRequest,
  [Types.STAFF_NUMBER_SUCCESS]: staffNumberSuccess,

  [Types.USER_CHANGE_EMAIL_REQUEST]: userChangeEmailRequest,
  [Types.USER_CHANGE_EMAIL_SUCCESS]: userChangeEmailSuccess,
  [Types.USER_CHANGE_EMAIL_RESET]: userChangeEmailReset,

  [Types.USER_CONFIRM_CODE_REQUEST]: userConfirmCodeRequest,
  [Types.USER_CONFIRM_CODE_SUCCESS]: userConfirmCodeSuccess,
  [Types.USER_CONFIRM_CODE_RESET]: userConfirmCodeReset,

  [Types.UPDATE_USER_INFO]: updateUserInfo,

  [Types.USER_FETCHING_RESET]: userFetchingReset,

  [Types.SET_VERIFICATION_LINK]: setVerificationLink,
})
